// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__Dxg0g","title-3":"styles_title-3__B1tK_","normal":"styles_normal__ECMIa"};